<template>
    <div class="retailer-list__item retailer-card" :id="'retailer-'+retailer.id" :class="isActive()">
        <div class="retailer-card__distance" v-if="retailer.distance && retailer.distance > 0">{{ retailer.distance }} km unna</div>

        <div class="retailer-card__body">
            <div class="retailer-card__col retailer-card__col--left">
                <h3 class="retailer-card__title">{{ retailer.name }}</h3>
                <address class="retailer-card__address">{{ retailer.street }}, {{ retailer.zipcode }} {{ retailer.city }} <span class="d-none">({{ retailer.municipality }})</span></address>

                <div class="retailer-card__contact">
<!--                    <a v-if="retailer.mobile" class="retailer-card__contact-link" :href="getTelLink(retailer.mobile)">Tel. {{retailer.mobile}}</a>-->
                    <a v-if="retailer.phone" class="retailer-card__contact-link" :href="getTelLink(retailer.phone)">Tel. {{retailer.phone}}</a>
                    <a v-if="retailer.email" class="retailer-card__contact-link" :href="getMailToLink(retailer.email)">{{retailer.email}}</a>
                </div>
            </div>

            <div class="retailer-card__col retailer-card__col--right">
                <div class="retailer-card__direction">
                    <button type="button" @click="changeRetailer" class="link link--primary d-ib-ipad">
                        <img src="/resources/images/svg/icon-map.svg" class="svg-icon">
                        <span>Vis på kart</span>
                    </button>
                    <a :href="getDirectionLink()" class="link link--primary" target="_blank">
                        <img src="/resources/images/svg/icon-route.svg" class="svg-icon">
                        <span>Vis veibeskrivelse</span>
                    </a>
                </div>
                <div class="retailer-card__buttons">
                    <a v-if="retailer.www" :href="retailer.www" class="btn btn--primary btn--md btn--to-link">Til forhandler</a>
                    <a  v-if="canSkyspanner()" :href="getSkyspannerLink()" target="_blank" class="btn btn--primary btn--md btn--to-link btn--invert">Bestill time</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props : {
            retailer: {
                type : Object,
            },
            userPosition: {
                type : String,
            },
            highlightedRetailer: {
                type : [Object, null],
            },
        },

        data()
        {
            return {
            }
        },


        created()
        {
        },

        methods:
        {
            isActive()
            {
                return (this.retailer.id === this.highlightedRetailer?.id) ? ' active ' : '';
            },

            unsetRetailer()
            {
                this.$emit('unset-retailer');
            },

            changeRetailer()
            {
                this.$emit('change-retailer', this.retailer.id, 'list');
            },

            getTelLink(number)
            {
                return 'tel:'+ number.replace(' ', '');
            },

            getMailToLink(email)
            {
                return 'mailto:'+ email;
            },

            getDirectionLink()
            {
                const destination = this.retailer.lat_lng;


                const origin = typeof this.userPosition === 'string' ? this.userPosition : '';

                return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`;
            },

            canSkyspanner()
            {
                // check if has shortname
                const shortname = (typeof this.retailer.shortname === 'string' && this.retailer.shortname.length > 0) ?
                      this.retailer.shortname :
                    null;

                // check if is enabled for bestill time
                const skyspanner = (typeof this.retailer.skyspanner === 'string' && this.retailer.skyspanner === '1');

                return (shortname && skyspanner);
            },

            getSkyspannerLink()
            {
                return  `https://service.gsbildeler.no/?verksted=${this.retailer.shortname}`;
            }
        },
    }
</script>